/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    ApplicationRef,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    Injector,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { PrintComponent } from '../../../../core/ui/print/print.component';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { SearchResultsPrintComponent } from './search-results-print.component';
import { filter, mergeMap, mergeMapTo, switchMap, switchMapTo, takeUntil, tap } from 'rxjs/operators';
import { LoggerService } from '../../../shared/services/logger.service';
import { WindowRefService } from '../../../../core/ui/services/windowRef.service';

@Component({
    selector: 'dash-gis-print-search',
    templateUrl: './print-search.component.html',
    styleUrls: ['./print-search.component.scss'],
})
export class PrintSearchComponent extends PrintComponent implements OnInit {
    constructor(
        private cdr: ChangeDetectorRef,
        private windowRef: WindowRefService,
        private logger: LoggerService,
        componentFactoryResolver: ComponentFactoryResolver,
        appRef: ApplicationRef,
        injector: Injector
    ) {
        super(componentFactoryResolver, appRef, injector);
    }

    protected getPortal<T>(component: ComponentType<T>): ComponentPortal<T> {
        return new ComponentPortal<T>(component, null, this.injector);
    }

    protected getPrintData(): void {
        this.printContent.instance.initialized$
            .pipe(
                filter((b) => !!b),
                switchMap(() => this.printContent.instance.dataSource.allResults$),
                takeUntil(this.stop$)
            )
            .subscribe(
                () => setTimeout(this.windowRef.nativeWindow.print, 0),
                (err) => this.logger.error(err)
            );
    }

    protected initializePrintComponent(): void {
        this.setInputs();
    }

    protected setInputs() {
        const changes: SimpleChanges = {};

        for (const input in this.inputs) {
            if (this.inputs.hasOwnProperty(input)) {
                const change = this.buildChange(this.printContent.instance[input], this.inputs[input]);
                this.printContent.instance[input] = this.inputs[input];
                changes[input] = change;
            }
        }

        if (this.printContent.instance.ngOnChanges) {
            this.printContent.instance.ngOnChanges(changes);
        }
        this.cdr.markForCheck();
    }

    ngOnInit() {}

    printResults() {
        this.print<SearchResultsPrintComponent>(SearchResultsPrintComponent);
    }
}
